<template>
  <div class="bg-second- p-4">
    <div class="col-11 mx-auto">
      <!-- Version Desktop -->
      <div class="hstack footer d-none d-md-flex">
        <a :href="SITE_URL + 'about'" target="_blank">À propos</a>
        <a :href="SITE_URL + 'legal'" target="_blank" class="ms-auto">Mentions légales</a>
        <a :href="SITE_URL + 'terms'" target="_blank" class="ms-auto">Conditions et Règles d'utilisation</a>
        <a :href="SITE_URL + 'contact'" target="_blank" class="ms-auto">Contact</a>
        <a :href="SITE_URL + 'faq'" target="_blank" class="ms-auto">FAQ</a>
        <a :href="SITE_URL + 'features'" target="_blank" class="ms-auto">Fonctionnalités</a>
      </div>

      <!-- Version Mobile -->
      <div class="footer-mobile d-md-none">
        <a :href="SITE_URL + 'about'" target="_blank">À propos</a>
        <a :href="SITE_URL + 'legal'" target="_blank">Mentions légales</a>
        <a :href="SITE_URL + 'terms'" target="_blank">CGU</a>
        <a :href="SITE_URL + 'contact'" target="_blank">Contact</a>
        <a :href="SITE_URL + 'faq'" target="_blank">FAQ</a>
        <a :href="SITE_URL + 'features'" target="_blank">Fonctionnalités</a>
      </div>

      <div class="mt-2 text-1 text-center text-white- fw-bold">
        © {{ new Date().getFullYear() }} SuitOps
      </div>
    </div>
  </div>
</template>

<style>
.footer a {
  font-size: 14px;
  color: var(--white) !important;
}

/* 2 colonnes */
.footer-mobile {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  text-align: center;
}

.footer-mobile a {
  display: block;
  font-size: 14px;
  color: var(--white) !important;
}
</style>

<script>
import Helper from '@/helpers/helper';
export default {
  name: "FooterComponent",
  data() {
    return {
      SITE_URL: "",
    }
  },
  created() {
    this.SITE_URL = Helper.SITE_URL
  }
}
</script>
